<div class="slider-nav">
    <div class="container blog-container">
        <div [ngClass]="{disabled: isPrevDisabled}" class="btn text-primary xsm" (click)="prev()"> < previous </div>
        <h2 class="blog-card-heading">{{label}}</h2>    
        <div [ngClass]="{disabled: isNextDisabled}" class="btn text-primary xsm" (click)="next()">next ></div>
    </div>
</div>